import React, {Suspense, lazy} from 'react';

import Quill from 'quill';
import ImageResize from 'quill-image-resize';
import 'react-quill-new/dist/quill.snow.css';
import {ValidatedControl} from 'src/contexts/validation-context';

import {QUIL_MODULES} from './constants';

if (!Quill.imports?.['modules/imageResize']) {
    Quill.register('modules/imageResize', ImageResize);
}

// Lazy load ReactQuill
const ReactQuill = lazy(() => import('react-quill-new'));

type Props = {
    value: string,
    setValue: (value: string) => void,
};

export const NotificationContent = ({value, setValue}: Props) => {

    return (
        <ValidatedControl name="notification-content">
            {() => (
                <Suspense fallback={<div>Loading editor...</div>}>
                    <style>{'.ql-editor img { max-width: 845px; height: auto; }'}</style>
                    <ReactQuill
                        theme="snow"
                        value={value}
                        onChange={setValue}
                        modules={QUIL_MODULES}
                    />
                </Suspense>
            )}
        </ValidatedControl>
    );
};
